export default __webpack_public_path__ + "static/media/measures.6387220e.svg";